import React from 'react';
import { Pager } from '@tag/tag-components-react-v4';
import cn from 'classnames';

import styles from './pagination.module.scss';

interface IPaginationProps {
  currentPage: number;
  totalPages: number;
  disabled?: boolean;
  onClickPage: (page: number) => void;
  className?: string;
}

export default function Pagination({
  currentPage,
  totalPages,
  onClickPage,
  disabled,
  className
}: IPaginationProps) {

  return (
    <div
      className={cn(styles.pagination, {
        [styles['pagination--disabled']]: disabled,
      }, className)}
    >
      {disabled && <div className={styles.overlay} />}

      <Pager
        page={currentPage}
        pageCount={totalPages}
        accent="teal"
        buttonCount={10}
        onPageRequest={(e) => onClickPage(e.page)}
      />
    </div>
  );
}
